import { Reveal, Eyebrow } from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "I showed Mrinalee a few photos and she helped me find a look that still felt like me. It stayed lovely through the ceremony and all the hugs after.",
    name: "Sakshi",
    event: "Bridal",
    makeupType: "Soft bridal glam",
  },
  {
    quote:
      "The morning felt so calm, even with everything going on. My makeup felt light, and I didn’t need to touch it up before the reception.",
    name: "Udichi",
    event: "Reception",
    makeupType: "Reception glam",
  },
  {
    quote:
      "I loved how the makeup looked in the photos without feeling heavy in person. Mrinalee listened to what I was comfortable with and got the details just right.",
    name: "Uma",
    event: "Editorial Shoot",
    makeupType: "Soft glam",
  },
];

export const Testimonials = () => (
  <section id="testimonials" data-testid="section-testimonials" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="text-center mb-14">
        <div className="flex justify-center">
          <Eyebrow index="07">Kind Words</Eyebrow>
        </div>
        <h2 className="font-serif-ed font-normal text-3xl sm:text-4xl lg:text-5xl mt-6 text-[#2A1F16]">
          Loved by <em className="text-[#96754D]">clients</em>
        </h2>
        <p className="mt-4 text-xs uppercase tracking-[0.2em] text-[#9C8871]">
          Illustrative client feedback
        </p>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-5">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.1} className="h-full">
            <blockquote
              data-testid={`testimonial-card-${i + 1}`}
              className="h-full bg-[#F4EBDD] border border-[#E9DCC8] rounded-2xl p-8 flex flex-col hover:border-[#B8893B]/40 transition-colors duration-500"
            >
              <span className="font-serif-ed text-6xl leading-none text-[#B8893B]/50" aria-hidden="true">
                &ldquo;
              </span>
              <p className="font-serif-ed italic text-lg sm:text-xl leading-relaxed text-[#2A1F16] flex-1 -mt-3">
                {t.quote}
              </p>
              <footer className="mt-8 pt-5 border-t border-[#E9DCC8] flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-[#2A1F16]">— {t.name}</p>
                  <p className="text-[11px] uppercase tracking-[0.22em] text-[#96754D] mt-1">{t.event}</p>
                </div>
                <span className="text-[9px] uppercase tracking-[0.18em] text-[#9C8871] border border-[#E9DCC8] rounded-full px-3 py-1">
                  {t.makeupType}
                </span>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
